import React, { useContext } from 'react';
import { Tab, TabProps } from '@mui/material';
import { UiContext } from 'shared/lib/contexts/uiContext';

export default function CustomTab(props: TabProps) {
  const { getFontSize } = useContext(UiContext);

  const f22 = getFontSize('f22');

  return (
    <Tab
      focusRipple={false}
      sx={{ fontSize: `${f22} !important`, color: 'text.primary', ...props.sx }}
      {...props}
    ></Tab>
  );
}
